/* eslint-disable no-useless-escape */
import { IMask } from 'react-imask';

export function toCurrency(value: number): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });
}

export function fromCurrency(value: string): number {
  return Number(value.replace(',', '.').replace(' ', ''));
}

export const currencyMask: IMask.AnyMaskedOptions = {
  lazy: false,
  mask: Number,
  thousandsSeparator: ' ',
  radix: ',',
  mapToRadix: [',', '.'],
};

export default toCurrency;
